/* ==========================================================================
   easysea SUMMER SALE '26 - interruttore e conto alla rovescia
   --------------------------------------------------------------------------
   Perche' l'accensione la fa il browser e non solo Liquid: le pagine del
   negozio possono essere servite da cache per qualche minuto, e una pagina
   generata alle 23:58 del 14 direbbe "campagna spenta" anche dopo mezzanotte.
   Liquid mette la classe al primo colpo (niente lampeggio, funziona senza JS),
   questo file la corregge subito dopo se il momento e' cambiato.

   Ora di riferimento: il timestamp del server, letto in pagina. Se l'orologio
   del dispositivo e' vicino a quello del server si usa il dispositivo, cosi'
   il conto scorre anche su una pagina rimasta aperta; se e' lontano piu' di
   sei ore (orologio sballato, tipico su tablet vecchi) si tiene il server.
   ========================================================================== */
(function () {
  var root = document.documentElement;
  var cfg = window.esSummer;
  if (!cfg || !cfg.start) return;

  var START = cfg.start * 1000;
  var END = cfg.end * 1000;
  var SERVER = cfg.now * 1000;
  var SKEW = Math.abs(Date.now() - SERVER) > 6 * 3600 * 1000 ? SERVER - Date.now() : 0;

  function now() {
    return Date.now() + SKEW;
  }

  /* Anteprima: ?summer=1 accende, ?summer=0 spegne. Resta per la sessione,
     cosi' si puo' navigare tutto il sito vestito prima del 15. */
  var forced = null;
  try {
    var q = new URLSearchParams(location.search).get('summer');
    if (q === '1' || q === 'preview') { sessionStorage.setItem('es-ss', '1'); }
    else if (q === '0' || q === 'off') { sessionStorage.setItem('es-ss', '0'); }
    var st = sessionStorage.getItem('es-ss');
    if (st === '1') forced = true;
    if (st === '0') forced = false;
  } catch (e) { /* navigazione privata: si tira dritto */ }

  function live() {
    if (forced !== null) return forced;
    var t = now();
    return t >= START && t < END;
  }

  function sync() {
    var on = live();
    root.classList.toggle('es-ss', on);
    root.classList.toggle('es-ss-over', !on);
    return on;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var on = sync();
    var left = Math.max(0, END - now());
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;

    var compact = (d > 0 ? d + cfg.l.d + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);

    var i, els;
    els = document.querySelectorAll('[data-ss-cd]');
    for (i = 0; i < els.length; i++) els[i].textContent = compact;

    var map = { d: d, h: h, m: m, s: sec };
    for (var k in map) {
      els = document.querySelectorAll('[data-ss-cd-' + k + ']');
      for (i = 0; i < els.length; i++) els[i].textContent = pad(map[k]);
    }

    /* Ultimo giorno: l'etichetta cambia da sola, senza che nessuno la tocchi. */
    if (on && d === 0) {
      els = document.querySelectorAll('[data-ss-label]');
      for (i = 0; i < els.length; i++) els[i].textContent = cfg.l.last;
    }
  }

  sync();
  tick();
  setInterval(tick, 1000);

  /* ------------------------------------------------------------------------
     Giacenza al cambio variante.
     Il tema rigenera la scheda prodotto quando cambi taglia, ma non sempre:
     dipende dal blocco. La mappa variante -> pezzi viaggia con il markup, cosi'
     il numero e' giusto in tutti e due i casi e non resta quello della prima
     taglia, che sarebbe una bugia scritta in grande.
     ------------------------------------------------------------------------ */
  function stock(box, id) {
    var map;
    try { map = JSON.parse(box.getAttribute('data-ss-stockmap') || '{}'); } catch (e) { return; }
    var qty = map[String(id)];
    var wrap = box.querySelector('[data-ss-stock]');
    if (!wrap) return;
    var max = parseInt(box.getAttribute('data-ss-threshold'), 10) || 10;
    if (typeof qty !== 'number' || qty <= 0 || qty > max) { wrap.hidden = true; return; }
    wrap.hidden = false;
    var txt = box.querySelector('[data-ss-stock-text]');
    if (txt) {
      txt.innerHTML = qty === 1
        ? box.getAttribute('data-ss-left-one')
        : box.getAttribute('data-ss-left-a') + ' <b>' + qty + '</b> ' + box.getAttribute('data-ss-left-b');
    }
    var bar = box.querySelector('[data-ss-stock-bar]');
    if (bar) bar.style.width = Math.max(6, Math.min(100, Math.round(qty * 100 / max))) + '%';
  }

  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    var boxes = document.querySelectorAll('[data-ss-pdp]');
    for (var i = 0; i < boxes.length; i++) stock(boxes[i], v.id);
  });
})();
